import { autoElement } from '../../../webmodule-common/components/src/common/lit-decorator-extended';
import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { DataEntryPageControlView } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import {
  MenuIconOption,
  PageButtonLocation,
  PageControl,
  PageControlOptions,
  PageManager
} from '../../../webmodule-common/other/ui/page-control';
import { SettingsStaffView } from './settings-staff-view';
import { currentUserClaims, IUserClaims } from '../../../webmodule-common/other/currentuser-claims';
import { DeploymentAccessAssignmentView } from './deployment-access-assignment-view';

@autoElement()
export class SettingsView extends DataEntryPageControlView {
  staffView: SettingsStaffView | null = null;
  userDeploymentAssignmentView: DeploymentAccessAssignmentView | null = null;
  private userClaims: IUserClaims;

  public async afterConstruction(): Promise<void> {
    this.staffView = await constructAsync(new SettingsStaffView());
    this.userClaims = currentUserClaims();
    if (this.userClaims.isSuperAdmin || this.userClaims.isSuppportManager || this.userClaims.isLicenseServerAdmin) {
      this.userDeploymentAssignmentView = await constructAsync(new DeploymentAccessAssignmentView());
    }
    await super.afterConstruction();
    this.pageControl.pageButtonLocation = PageButtonLocation.right;
  }

  public getTitle() {
    return '%%License Server%% Settings';
  }

  public async setActiveTabByHash() {
    await this.pageControl.applyWindowHash();
  }

  createPageControl(): PageControl {
    // build static pages for each of the configured table settings
    const getInitialPageManagers = (): PageManager[] => {
      const pages: PageManager[] = [this.staffView!.createPageManager()];
      if (this.userDeploymentAssignmentView) {
        pages.push(this.userDeploymentAssignmentView.createPageManager());
      }
      return pages;
    };
    const menu: MenuIconOption[] = [];
    const options: PageControlOptions = {
      defaultTabIndex: 0,
      menuIcons: menu,
      pageInitializer: () => getInitialPageManagers()
    };
    return new PageControl(options);
  }

  async prepareForSave(): Promise<void> {
    //DOES NOTHING HANDLED BY CHILDREN
  }

  public internalDataChanged(): boolean {
    return false;
  }
}
